var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassword = function SvgPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.25 17.77v-1.5h19.5v1.5zm.842-6.012-1.03-.596.907-1.596H1.154V8.373h1.815l-.907-1.546 1.03-.596L4 7.777l.908-1.546 1.03.596-.907 1.546h1.815v1.193H5.031l.908 1.595-1.031.597L4 10.162zm8 0-1.03-.596.907-1.596H9.154V8.373h1.815l-.907-1.546 1.03-.596L12 7.777l.908-1.546 1.03.596-.907 1.546h1.815v1.193h-1.815l.908 1.595-1.031.597L12 10.162zm8 0-1.03-.596.907-1.596h-1.815V8.373h1.815l-.907-1.546 1.03-.596L20 7.777l.908-1.546 1.03.596-.907 1.546h1.815v1.193h-1.815l.908 1.595-1.031.597L20 10.162z"
  })));
};
export default SvgPassword;